// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

body,
html {
  margin: 0;
  padding: 0;
  font-family: "Montserrat", sans-serif !important;
}

.layout {
  display: flex;
  height: 100vh;
}

.header {
  background-color: #333;
  color: white;
  padding: 1rem;
  text-align: center;
  width: 100%;
}

.sidebar {
  background-color: #f4f4f4;
  width: 250px;
  padding: 1rem;
  box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.1);
}

.main-content {
  flex-grow: 1;
  background-color: #f5f5f5;
  margin-left: 240px;
  align-self: flex-start;
  overflow: hidden;
}
.main-content.hide-sidebar {
  margin-left: 0px;
}

.p-highlighter {
  color: #495057 !important;
  background-color: #ff9800 !important;
  border-right: 6px solid white !important;
}
/* In your stylesheet */
.p-highlighter .p-menuitem-text {
  color: red;
}

.page-wrapper {
  margin-top: 8px;
  font-family: "Montserrat", sans-serif !important;
}
body,
.p-component {
  font-family: "Montserrat", sans-serif !important;
}
.fw-600 {
  font-weight: 600 !important;
}
.fw-400 {
  font-weight: 400 !important;
}
.fs-14 {
  font-size: 14px !important;
}
.fs-18 {
  font-size: 18px !important;
}
.fs-20 {
  font-size: 20px !important;
}
.panel-height {
  max-height: 400px;
  overflow: auto;
}

/* For Webkit-based browsers (Chrome, Safari, Edge) */
.panel-height::-webkit-scrollbar {
  width: 5px; /* Scrollbar width */
}

.panel-height::-webkit-scrollbar-thumb {
  background-color: #888; /* Color of the scrollbar thumb */
  border-radius: 5px; /* Rounded corners for the scrollbar thumb */
}

.panel-height::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* Color when hovering over the scrollbar */
}

.panel-height::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* Background color of the scrollbar track */
}
/* CSS for alignment */

.header-label {
  color: #808080;
  margin-top: 5px;
}

.text-gray {
  color: #808080 !important;
}

/* Adjust DataTable column widths for alignment */
.table {
  table-layout: fixed;
  width: 100%;
}

.table .p-datatable-tbody td {
  text-align: center;
  vertical-align: middle;
}

.table tbody tr.table-row {
  border-bottom: 1px solid #dee2e6 !important;
}

.table tbody tr:first-child.table-row {
  border-bottom: 1px solid #dee2e6 !important;
}
.table.survey-table tbody tr {
  border-bottom: 1px solid #999 !important;
}
.table.survey-table tbody tr:first-child {
  border-bottom: 1px solid #999 !important;
}

.table.survey-table td .resCollapseBtnCont {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 12px;
  bottom: -12px;
  z-index: 5;
  width: 22px;
  height: 22px;
  background-color: #333333;
  color: #ffffff;
  border-radius: 50%;
  cursor: pointer;
}

.table-col-bg-color {
  background-color: rgb(241 242 242) !important;
}

@media (max-width: 768px) {
  /* Responsive styles */
  .household-chip {
    font-size: 16px;
    padding: 4px 8px;
  }
  .header-label {
    font-size: 10px;
  }
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(
    --bs-table-color-state,
    var(--bs-table-color-type, var(--bs-table-color))
  );
  background-color: var(--bs-table-bg);
  border-bottom-width: 0 !important; /* Remove bottom border */
  box-shadow: inset 0 0 0 9999px
    var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}

.text-light-gray {
  color: #9e9e9e !important;
}
.text_dark {
  color: #002133 !important;
}
.icon-color {
  color: #bdbdbd !important;
}
.text-dark-gray {
  color: #666666 !important;
}
.text-red {
  color: #f44336 !important;
}
.w-90 {
  width: 90% !important;
}
.bg-white {
  background-color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,wCAAwC;AAC1C;AACA,uBAAuB;AACvB;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gDAAgD;AAClD;AACA;;EAEE,gDAAgD;AAClD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,UAAU,EAAE,oBAAoB;AAClC;;AAEA;EACE,sBAAsB,EAAE,iCAAiC;EACzD,kBAAkB,EAAE,4CAA4C;AAClE;;AAEA;EACE,sBAAsB,EAAE,2CAA2C;AACrE;;AAEA;EACE,yBAAyB,EAAE,4CAA4C;AACzE;AACA,sBAAsB;;AAEtB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,sBAAsB;EACtB;;;GAGC;EACD,oCAAoC;EACpC,iCAAiC,EAAE,yBAAyB;EAC5D;gFAC8E;AAChF;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap\");\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nbody,\nhtml {\n  margin: 0;\n  padding: 0;\n  font-family: \"Montserrat\", sans-serif !important;\n}\n\n.layout {\n  display: flex;\n  height: 100vh;\n}\n\n.header {\n  background-color: #333;\n  color: white;\n  padding: 1rem;\n  text-align: center;\n  width: 100%;\n}\n\n.sidebar {\n  background-color: #f4f4f4;\n  width: 250px;\n  padding: 1rem;\n  box-shadow: 2px 0px 5px rgba(0, 0, 0, 0.1);\n}\n\n.main-content {\n  flex-grow: 1;\n  background-color: #f5f5f5;\n  margin-left: 240px;\n  align-self: flex-start;\n  overflow: hidden;\n}\n.main-content.hide-sidebar {\n  margin-left: 0px;\n}\n\n.p-highlighter {\n  color: #495057 !important;\n  background-color: #ff9800 !important;\n  border-right: 6px solid white !important;\n}\n/* In your stylesheet */\n.p-highlighter .p-menuitem-text {\n  color: red;\n}\n\n.page-wrapper {\n  margin-top: 8px;\n  font-family: \"Montserrat\", sans-serif !important;\n}\nbody,\n.p-component {\n  font-family: \"Montserrat\", sans-serif !important;\n}\n.fw-600 {\n  font-weight: 600 !important;\n}\n.fw-400 {\n  font-weight: 400 !important;\n}\n.fs-14 {\n  font-size: 14px !important;\n}\n.fs-18 {\n  font-size: 18px !important;\n}\n.fs-20 {\n  font-size: 20px !important;\n}\n.panel-height {\n  max-height: 400px;\n  overflow: auto;\n}\n\n/* For Webkit-based browsers (Chrome, Safari, Edge) */\n.panel-height::-webkit-scrollbar {\n  width: 5px; /* Scrollbar width */\n}\n\n.panel-height::-webkit-scrollbar-thumb {\n  background-color: #888; /* Color of the scrollbar thumb */\n  border-radius: 5px; /* Rounded corners for the scrollbar thumb */\n}\n\n.panel-height::-webkit-scrollbar-thumb:hover {\n  background-color: #555; /* Color when hovering over the scrollbar */\n}\n\n.panel-height::-webkit-scrollbar-track {\n  background-color: #f1f1f1; /* Background color of the scrollbar track */\n}\n/* CSS for alignment */\n\n.header-label {\n  color: #808080;\n  margin-top: 5px;\n}\n\n.text-gray {\n  color: #808080 !important;\n}\n\n/* Adjust DataTable column widths for alignment */\n.table {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.table .p-datatable-tbody td {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.table tbody tr.table-row {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n\n.table tbody tr:first-child.table-row {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n.table.survey-table tbody tr {\n  border-bottom: 1px solid #999 !important;\n}\n.table.survey-table tbody tr:first-child {\n  border-bottom: 1px solid #999 !important;\n}\n\n.table.survey-table td .resCollapseBtnCont {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 12px;\n  bottom: -12px;\n  z-index: 5;\n  width: 22px;\n  height: 22px;\n  background-color: #333333;\n  color: #ffffff;\n  border-radius: 50%;\n  cursor: pointer;\n}\n\n.table-col-bg-color {\n  background-color: rgb(241 242 242) !important;\n}\n\n@media (max-width: 768px) {\n  /* Responsive styles */\n  .household-chip {\n    font-size: 16px;\n    padding: 4px 8px;\n  }\n  .header-label {\n    font-size: 10px;\n  }\n}\n.table > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n  color: var(\n    --bs-table-color-state,\n    var(--bs-table-color-type, var(--bs-table-color))\n  );\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 0 !important; /* Remove bottom border */\n  box-shadow: inset 0 0 0 9999px\n    var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));\n}\n\n.text-light-gray {\n  color: #9e9e9e !important;\n}\n.text_dark {\n  color: #002133 !important;\n}\n.icon-color {\n  color: #bdbdbd !important;\n}\n.text-dark-gray {\n  color: #666666 !important;\n}\n.text-red {\n  color: #f44336 !important;\n}\n.w-90 {\n  width: 90% !important;\n}\n.bg-white {\n  background-color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
